import * as React from 'react';
import {FormattedMessage, injectIntl} from 'react-intl';
import {CommentStatusOptions} from '@models/comment';
import Search, {SearchInputType} from "@components/custom/Search";


interface SearchInputProps {
  search: (filter: object) => any;
  form: any;
  intl: any;
}

const SearchCommentsComponent: React.FC<SearchInputProps> = props => {
  const {search} = props;
  
  const inputs = [{
    name: "video_id",
    label: <FormattedMessage id="app.select_video" defaultMessage={`Select Video`}/>,
    type: SearchInputType.VIDEO,
    size : 12
  }, {
    name: "status",
    label: <FormattedMessage id="app.select_status_comment" defaultMessage={`Select Comment Status`}/>,
    type: SearchInputType.SELECT,
    options: CommentStatusOptions,
    size : 12
  }, {
    name: "from",
    label: <FormattedMessage id="app.from" defaultMessage={`From`}/>,
    type : SearchInputType.DATE,
    size : 12
  },{
    name : "to",
    label : <FormattedMessage id="app.to" defaultMessage={`To`}/>,
    type : SearchInputType.DATE,
    size : 12
  }];
  
  return <Search inputs={inputs} search={search}/>
  
};

export default injectIntl(SearchCommentsComponent)